export const TASK_ACTION_CONFIRMATION_MESSAGE = 'Action execution confirmation';

export const TASK_ACTION_CONFIRM_BUTTON_NAME = 'Proceed';
